import { render, staticRenderFns } from "./editCollectionDialog.vue?vue&type=template&id=998f851a&scoped=true"
import script from "./editCollectionDialog.vue?vue&type=script&lang=js"
export * from "./editCollectionDialog.vue?vue&type=script&lang=js"
import style0 from "./editCollectionDialog.vue?vue&type=style&index=0&id=998f851a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "998f851a",
  null
  
)

export default component.exports